/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1LanguagesQueryResponse } from '../../types/GetV1Languages.ts'

export const getV1LanguagesQueryKey = () => [{ url: '/v1/Languages' }] as const

export type GetV1LanguagesQueryKey = ReturnType<typeof getV1LanguagesQueryKey>

/**
 * {@link /v1/Languages}
 */
export async function getV1Languages(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1LanguagesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Languages`,
        ...requestConfig,
    })
    return res
}

export function getV1LanguagesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1LanguagesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1LanguagesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1LanguagesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Languages(config)
        },
    })
}

/**
 * {@link /v1/Languages}
 */
export function useGetV1Languages<
    TData = ResponseConfig<GetV1LanguagesQueryResponse>,
    TQueryData = ResponseConfig<GetV1LanguagesQueryResponse>,
    TQueryKey extends QueryKey = GetV1LanguagesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1LanguagesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1LanguagesQueryKey()

    const query = useQuery(
        {
            ...getV1LanguagesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
